import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import sentry from 'legacy/utils/sentry'

import { getRatecon } from '../../use-cases/getRatecon'
import { useLoadOffer } from './useLoadOffer'
import { useShipment } from './useShipment'

export function useLoadSetup() {
  const { loadOffer, isFetchingLoadOffer, fetchLoadOfferStatus, fetchLoadOfferByLoadId } =
    useLoadOffer()
  const { shipment, fetchShipmentStatus, fetchShipment } = useShipment()

  const [fetchRateConfirmationStatus, setFetchRateConfirmationStatus] = useState(
    RequestStatus.Initial
  )

  const isFetchingRateConfirmation = fetchRateConfirmationStatus === RequestStatus.Pending
  const isLoading = isFetchingLoadOffer || isFetchingRateConfirmation

  const fetchRateConfirmationByRefNumber = useCallback(async (refNumber: string) => {
    setFetchRateConfirmationStatus(RequestStatus.Pending)

    try {
      const fileURL = await getRatecon(refNumber)
      setFetchRateConfirmationStatus(RequestStatus.Done)
      return fileURL
    } catch (error) {
      sentry.log(error)
      setFetchRateConfirmationStatus(RequestStatus.Error)
      throw new Error('Cannot fetch rate confirmation', {
        cause: error as Error,
      })
    }
  }, [])

  return {
    shipment,
    loadOffer,
    isLoading,
    isFetchingLoadOffer,
    fetchShipmentStatus,
    fetchLoadOfferStatus,
    isFetchingRateConfirmation,
    fetchShipment,
    fetchLoadOfferByLoadId,
    fetchRateConfirmationByRefNumber,
  }
}
